export type SafetyAction =
  | 'heat-direct-flame'
  | 'heat-sealed-tube'
  | 'move-hot-tube'
  | 'add-sodium-hydroxide'
  | 'add-copper-sulfate'
  | 'use-ethanol-near-flame'
  | 'boil-dry';

export interface SafetyAssessment {
  safe: boolean;
  blocked: boolean;
  warnings: string[];
}

const safetyMessages: Record<SafetyAction, string> = {
  'heat-direct-flame': 'Do not heat Benedict’s mixture directly over a flame. Use a hot-water bath to reduce spitting and fire risk.',
  'heat-sealed-tube': 'Never heat a sealed test tube. Pressure can build and eject hot liquid or break the glass.',
  'move-hot-tube': 'Use a test-tube holder or heat-resistant tongs before moving a hot tube.',
  'add-sodium-hydroxide': 'Sodium hydroxide is corrosive. Wear eye protection and avoid skin contact.',
  'add-copper-sulfate': 'Copper(II) sulfate is harmful and an environmental hazard. Avoid contact and collect waste appropriately.',
  'use-ethanol-near-flame': 'Ethanol is flammable. Keep it away from the Bunsen burner and switch off ignition sources before use.',
  'boil-dry': 'Do not allow the water bath or sample to boil dry. Stop heating and refill the bath safely.',
};

const blockedActions: SafetyAction[] = ['heat-direct-flame', 'heat-sealed-tube', 'boil-dry'];

export function assessSafetyAction(action: SafetyAction): SafetyAssessment {
  return {
    safe: !blockedActions.includes(action),
    blocked: blockedActions.includes(action),
    warnings: [safetyMessages[action]],
  };
}

export function getSafetyWarning(action: SafetyAction): string {
  return safetyMessages[action];
}